import { Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import { combineClasses } from '../../../utils/styling';
import { useStyles } from '../styles';
import { defaultTemplateMemberSize, row, TemplateContainer } from '../utils';
import { createEmptyMember } from '../utils/ruleFactory';
import TemplateFieldMember from './templateFieldMember';
import { getFieldName } from './utils';

export const TemplateField = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  const usedContainer = props.usedContainer ?? TemplateContainer;
  const templateContainer = usedContainer.useContainer();

  const [field, setField] = useState({ members: [] });

  useEffect(() => {
    const fieldObject = templateContainer.getField(props);

    const members = fieldObject.members.map(m => ({ id: v4(), ...m }));
    setField({ members });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const createMember = () => {
    const newMembers = [...field.members];
    newMembers.push({
      id: v4(),
      ...createEmptyMember(),
    });
    setField({ members: newMembers });
    templateContainer.addFieldMember(props);
  };

  const removeMember = memberIndex => {
    const newMembers = [...field.members];
    newMembers.splice(memberIndex, 1);
    setField({ members: newMembers });
    templateContainer.removeFieldMember(props, memberIndex);
  };

  return (
    <>
      {field.members.map((member, index) => (
        <TemplateFieldMember
          key={member.id}
          selectOptions={props.selectOptions}
          rule={props.rule}
          fieldName={props.fieldName}
          transactionType={props.transactionType}
          objectIndex={props.objectIndex}
          memberIndex={index}
          member={member}
          removeMember={removeMember}
          usedContainer={usedContainer}
        />
      ))}
      {field.members && field.members.length === 0 && (
        <Grid
          container
          item
          alignItems="flex-end"
          justifyContent="space-evenly"
          wrap="nowrap"
          direction="column"
          {...defaultTemplateMemberSize}
        >
          <Grid container item xs={row}>
            <label
              className={combineClasses([
                classes.Bold,
                classes.UpperCase,
                classes.FieldLabel,
              ])}
            >
              {getFieldName(props, t)}
              <Button
                name="addMember"
                aria-label="addMember"
                variant="contained"
                color="primary"
                onClick={createMember}
                className={combineClasses([
                  props.addButtonAlwaysVisible ? '' : classes.DisplayNoneMock,
                  classes.AddMemberButton,
                  classes.SingleAddMemberButton,
                ])}
              >
                <AddIcon />
              </Button>
              {!props.transactionType && !props.addButtonAlwaysVisible && (
                <div data-value="defaultField" className={classes.DefaultField}>
                  {t('templateDialog.default')}
                </div>
              )}
            </label>
          </Grid>
        </Grid>
      )}
      {field.members.length > 0 && (
        <Grid container alignItems="center" item xs={1}>
          <Button
            name="addMember"
            aria-label="addMember"
            variant="contained"
            color="primary"
            onClick={createMember}
            classes={{
              root: combineClasses([
                props.addButtonAlwaysVisible ? '' : classes.Hidden,
                classes.AddMemberButton,
              ]),
            }}
          >
            <AddIcon />
          </Button>
        </Grid>
      )}
    </>
  );
};

TemplateField.propTypes = {
  selectOptions: PropTypes.object,
  rule: PropTypes.object,
  fieldName: PropTypes.string,
  transactionType: PropTypes.string,
  objectIndex: PropTypes.number,
  addButtonAlwaysVisible: PropTypes.bool,
  usedContainer: PropTypes.object,
};
